// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"628e8162","189":"437ce137","269":"5b047e4b","392":"1c8a8e82","488":"de69f5aa","553":"1174abde","658":"ca26dc2e","702":"72dfcac6","762":"efb16b7f","825":"0e09f56b","845":"fb67bcb4","938":"959af062"}[chunkId] + ".chunk.js";
};